import { Injectable } from '@angular/core';

import { Subject } from 'rxjs';

import {
  createClient,
  SupabaseClient,
} from '@supabase/supabase-js';

import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SupabaseService {
  client: SupabaseClient;
  readonly authError$ = new Subject<Response | { status?: number; message?: string }>();

  constructor() {
    const wrappedFetch: typeof fetch = async (input, init) => {
      const res = await fetch(input as any, init as any);
      if (res.status === 401 || res.status === 403) {
        this.authError$.next(res);
      }
      return res;
    }

    this.client = createClient(environment.supabaseConfig.SUPABASE_PUBLIC_URL, environment.supabaseConfig.ANON_KEY, {
      global: {
        fetch: wrappedFetch
      }
    });
  }

  getTemporaryClient(): SupabaseClient {
    return createClient(
      environment.supabaseConfig.SUPABASE_PUBLIC_URL,
      environment.supabaseConfig.ANON_KEY,
      {
        auth: {
          persistSession: false,
        }
      }
    );

  }

  subscribeToChanges(tableName: string, callback: (payload: any) => void) {
    return this.client
      .channel(`${tableName}_changes`)
      .on('postgres_changes',
        {event: '*', schema: 'public', table: tableName},
        callback
      )
      .subscribe();
  }
}
